import texts from './en.json';
import { useContext } from 'react';
import AuthContext from '@context/auth';
import useWindowDimensions from '@hooks/useWindowDimensions';
import MobileRmConsultationBanner from './MobileRmConsultationBanner';
import { DesktopRmConsultationBanner } from './DesktopRmConsultationBanner';

const RmConsultationBanner = () => {
    const { rmDetails, showRMDetails } = useContext(AuthContext);
    const whatsappLink = `https://wa.me/${rmDetails?.mobile}`;
    const { width } = useWindowDimensions();

    return (
        <>
            {width > 768 ? (
                <DesktopRmConsultationBanner
                    whatsappLink={whatsappLink}
                    rmDetails={rmDetails}
                    showRMDetails={showRMDetails}
                />
            ) : (
                <MobileRmConsultationBanner
                    rmDetails={rmDetails}
                    showRMDetails={showRMDetails}
                    whatsappLink={whatsappLink}
                    title={texts.NeedHelpFindingRightOpportunity}
                    isOpportunityListing
                />
            )}
        </>
    );
};

export default RmConsultationBanner;
